import { RootState } from 'constants/interfaces'
import React, { memo, useMemo } from 'react'
import CommentSection from '.'
import { getMediaCid } from 'utils'
import { useSelector } from 'react-redux'
import type { SubtaskWithUuid } from '../TasksOverview/model/media'

interface IProps {
  splitView?: boolean
  composerTarget?: HTMLDivElement | null
  onCommentOverlayOpenChange?: (open: boolean) => void
  analysisLoading?: boolean
  aiScore?: number
  subtask: SubtaskWithUuid
  resultContextId: string
  objectType: number
  mediaIndex: number
  retail_id_context_id: string
  recurrence_ts: string | null
  media: string[]
  tid: string
  isMediaLoading: boolean
  imageToComment?: string
  onImageToCommentConsumed?: () => void
  isAIComment: boolean
  targetParentCommentId?: string | null
  targetCommentId?: string | null
}

export const ResultCommments: React.FC<IProps> = memo(
  ({
    splitView,
    composerTarget,
    onCommentOverlayOpenChange,
    analysisLoading,
    aiScore,
    subtask,
    resultContextId,
    objectType,
    mediaIndex,
    retail_id_context_id,
    recurrence_ts,
    media,
    tid,
    isMediaLoading,
    imageToComment,
    onImageToCommentConsumed,
    isAIComment,
    targetParentCommentId,
    targetCommentId,
  }) => {
    const { st_id } = subtask
    const uid = useSelector((state: RootState) => state.auth.uid)!

    const { cdn, rid, retailUsersObject } = useSelector((state: RootState) => state.config.config)

    const url = media?.length > 0 ? media[mediaIndex] : ''

    const mediaHash = useMemo(() => getMediaCid({ url, cdn, rid }), [cdn, rid, url])

    if (!url) {
      return null
    }

    const contextIdRecurrenceTs = `${resultContextId}${recurrence_ts ? '_' + recurrence_ts : ''}`
    const oid = `${st_id}_${contextIdRecurrenceTs}`

    const result_level = Object.keys(retailUsersObject!).includes(resultContextId) ? 'user' : 'group'

    return (
      <CommentSection
        splitView={splitView}
        composerTarget={composerTarget}
        onCommentOverlayOpenChange={onCommentOverlayOpenChange}
        analysisLoading={analysisLoading}
        aiScore={aiScore}
        oid={oid}
        rg_id={retail_id_context_id!}
        objectType={objectType}
        parentCid={mediaHash!}
        tid={tid}
        mediaIndex={mediaIndex}
        created_by={uid}
        result_context_id={resultContextId}
        result_level={result_level}
        {...(recurrence_ts ? { recurrence_ts } : {})}
        isMediaLoading={isMediaLoading}
        imageToComment={imageToComment}
        onImageToCommentConsumed={onImageToCommentConsumed}
        isAIComment={isAIComment}
        targetParentCommentId={targetParentCommentId}
        targetCommentId={targetCommentId}
      />
    )
  }
)
